import {CustomerManageModify} from "@/features/manage";
import {vars} from "@/shared/lib";
import {Column, Indicator} from "@/shared/ui";
import {createFileRoute} from "@tanstack/react-router";
import {Suspense} from "react";

export const Route = createFileRoute("/(auth)/_layout/manage/customer-manage/$customerManageId/modify")({
	component: CustomerManageModifyPage
});

function CustomerManageModifyPage() {
	return (
		<Column fullWidth style={{gap: vars.size[16]}}>
			<Suspense fallback={<Indicator />}>
				<CustomerManageModify />
			</Suspense>
		</Column>
	);
}
